export const RG_KNOWLEDGE_VERSION = 'Final-v0.8';
export const RG_FULL_REFERENCE_CHARS = 20285;

export const RG_KERNEL = `宇宙源頭的意識經宇宙生命樹三部曲向下實現：RG以五秒歸零、中軸、BMSA軸與六力育成5D小i；OG以聖光心器、衷愛軸與People Ware形成管道及場域；《1001宇宙文明》再以7D預知力、8D共創力促進文明連網。主權積分累積長期可信行動形成治理權柄；Ware三軸則透過Hardware載具與成果、Software流程與業務、People Ware角色與共同體，使宇宙源頭的意識真正走進物質。RG只整理1D至5D中軸實踐與Evidence，不判定維度、授權、主權積分或神性層次。`;

export const RG_RESPONSE_FRAME = [
  '你現在可能卡在哪裡',
  '本次主軸',
  '五秒歸零提問',
  '今天的一個行動',
  '要留下的Evidence',
  '安全或專業轉介提醒',
];

export const RG_CHAPTERS = [
  {
    id: 'C01', title: '每一個人都站在旋轉門前',
    routeWhen: ['剛被觸發', '觸發', '反擊', '回擊', '逃避', '後悔', '不知道從哪開始', '壓力', '身體緊縮', '失去方向', '沒有方向'],
    summary: '事件與舊反應完成之間，以五秒取回方向權。先分開事實、身體、解讀、衝動與結果，不急著挖完原因。',
    prompt: '停、息、歸零。剛才的事實是什麼？身體先出現什麼？若舊反應不替我決定，現在真正要守住的是什麼？',
    action: '延後自動反應，完成一個不傷害自己與他人、又能處理真問題的小回應。',
    evidence: '停頓出現；能分辨事實與解讀；回應後減少後悔。',
  },
  {
    id: 'C02', title: '回到本心',
    routeWhen: ['本心', '想逃避', '重大選擇', '討好', '頭腦情緒身體', '身體訊號', '情緒衝突', '不知道是否逃避', '很想做', '長期問題', '使命逼自己', '健康'],
    summary: '分辨頭腦、情緒、身體與本心；本心須同時接受事實、關係、長期方向與可承擔結果檢驗。',
    prompt: '停、息、歸零。現在最大聲的是頭腦、情緒、身體，還是較完整的本心方向？哪一項需要先查證？',
    action: '選一個最小而完整的步驟：休息、完成工作、說明界線、取得資訊或尋求專業協助。',
    evidence: '身體承載、真實關係、工作完成、責任清楚或錯誤修補出現改善。',
  },
  {
    id: 'C03', title: '意識根系：失去焦點不完全是你的錯',
    routeWhen: ['原生家庭', '父母', '小孩', '內在小孩', '潛意識', '自律神經', '集體壓力', '集體慣性', '界線', '怕失去愛', '完美才敢開始', '過度工作', '組織規則', '明知卻做不到'],
    summary: '反覆模式可能來自身體、求生反應、顯意識、潛意識與集體慣性；理解根系是為重新選擇，不是找罪人。',
    prompt: '停、息、歸零。是身體警報、舊求生方式、潛意識腳本，還是集體的「應該」在替我決定？今天能補哪一小點？',
    action: '改變一個可觀察環節，例如縮小承諾、說出界線、調整環境或請求支持。',
    evidence: '更早辨識舊腳本；作出一次不同選擇；安全感與自主增加。',
  },
  {
    id: 'C04', title: '旋轉是為了沿軸成長',
    routeWhen: ['重複', '一直發生', '相同問題', '舒適圈', '換工作', '換關係', '英雄救火', '談錢', '換工具', '拖延', '努力沒有成長', '全局', '主軸', '沿軸成長'],
    summary: '同樣事件再現不等於退步；比較前後條件、展開相關軸線，找出能統攝其他軸線的主軸與最低缺口。',
    prompt: '停、息、歸零。這一圈與上次相同在哪裡？新增了什麼？哪條主軸能讓這次真正增加高度？',
    action: '選一個能改變循環結構的補點，設定完成時間與回看點。',
    evidence: '恢復時間縮短；同類事件出現新回應；增加一項穩定能力。',
  },
  {
    id: 'C05', title: '覺之・有覺有之',
    routeWhen: ['懂很多', '沒有改變', '靈感', '沒有落地', '落地', '使命', '很忙', '感動但生活不變', '知道卻沒說', '構想', '第一個交付', '覺察', '一點真'],
    summary: '「覺」接到一點真訊息，「之」讓它經BMSA進入選擇、工作、關係、服務與現實。',
    prompt: '停、息、歸零。我真正覺到的一點是什麼？若它不是漂亮話，今天要經過我成為什麼？',
    action: '完成一個有起訖、有對象、有結果的一點真，讓結果回到下一次校正。',
    evidence: '覺察轉成選擇與完成；結果可回看；行動增加能力而非依賴。',
  },
  {
    id: 'C06', title: '臣服：停止與生命拔河',
    routeWhen: ['控制', '證明自己', '授權', '不敢授權', '怕失去', '舊身分', '拔河', '硬撐', '硬扛', '凡事自己撐住', '一直扛', '自己扛', '扛著', '事情做完', '全部答應', '不能承認錯誤', '方法錯了'],
    summary: '臣服不是失去自主，而是停止用否認、防衛、控制與舊身分消耗生命；不能被用來要求忍受暴力、操控或違法。',
    prompt: '停、息、歸零。我正在和什麼拔河？若不必維持舊身分或證明自己，此刻本心要我作什麼？',
    action: '授權、調整節奏、承認錯誤、拒絕不實承諾或接受回饋，完成其中一項。',
    evidence: '能傾聽修正；適度授權；尊重身體；界線更清楚。',
  },
  {
    id: 'C07', title: '守在中軸：BMSA四軸共振',
    routeWhen: ['執行', '交付', '自我實現', '成所作智', '主動補洞', '補洞', '小i', '中軸', 'BMSA', '身心意行', '老闆', '同事', '不同要求', '只會評論', '構想沒有流程', '無人負責', '團隊缺口', '流程', '企業', '服務', '系統', '責任', '角色位置', '交接'],
    summary: '小i不是頭銜；是在中軸辨識位置，以BMSA檢查承載、心智、意向與行動，主動補一個真缺口並形成交接。',
    prompt: '停、息、歸零。真正缺什麼？這是不是我的位置？BMSA哪一軸未接上？我能作成哪一點？',
    action: '完成可交付的補洞成果，標明對象、期限、資源、責任與交接。',
    evidence: '成果改善真問題；BMSA缺口縮小；他人或系統能力同步增加。',
  },
  {
    id: 'C08', title: '修煉就在今天：完成1D至5D能力整合',
    routeWhen: ['能力盤點', '績效', '生活失衡', '方法失效', '舊方法失效', '幾D', '哪一D', '5D', '鑽石心錨', '肉身揚升', '帶著肉身', '入世成功', '生命力', '生產力', '承擔力', '執行力', '創新力', '創意', '身體撐不住', '撐不住', '投入沒有產出', '責任不清', '無法閉環', '身體與執行'],
    summary: '依真實事件找最低能力缺口：1D生命力、2D生產力、3D承擔力、4D執行力、5D創新力；在中軸錨定6D貫徹力。',
    prompt: '停、息、歸零。此事最缺哪一力？最低的一層若補一點，整體會如何改變？',
    action: '只選一個最低能力做七天微型實驗，記錄起點、行動、結果與回看日期。',
    evidence: '節律可持續；投入形成產出；責任被承擔；任務閉環；新方法可驗證。',
  },
  {
    id: 'C09', title: '感恩來時路：站在5.5D旋轉門前',
    routeWhen: ['成功後', '下一步', '感恩', '傷害', '服務', '供應', '生命供應', '所得', '收入', '一之軸理', '使命與生活', '準備走向OG', 'OG', '制度', '公平回饋', '家庭責任', '他人依賴'],
    summary: '感恩不是取消界線；把能力、所得、守信、公平與服務放進可查核制度。RG只觀察穿越準備，不宣告進入OG。',
    prompt: '停、息、歸零。我的能力與所得從何而來、流向哪裡？哪個選擇能同時守住自己、他人與更大生命？',
    action: '把一項價值轉成可查核安排：完成承諾、改善分工、公平回饋或增加服務對象自主。',
    evidence: '感恩進入責任；成功不耗損生命；理念與制度較一致。',
  },
  {
    id: 'C10', title: '今天開始你的第一年',
    routeWhen: ['如何開始', '一年實修', '第一年', '七日', '百日', '一年回看', 'Portal', '七欄紀錄', '紀錄', '回落', '補修', '完成RG', '打卡', '規畫太大', '短期努力後中斷', '生活證據'],
    summary: '一年築基讓五秒智慧、七欄、五種能力與Evidence經過真實季節；比較能力變化，不追逐稱號。',
    prompt: '停、息、歸零。今天的真實事件是什麼？在哪裡偏軸？能行出哪一點真並留下什麼Evidence？',
    action: '完成今天一筆七欄紀錄，設定七日、百日與一年回看點；中斷後從當天接續。',
    evidence: '回軸時間縮短；反覆模式提早辨識；工作關係更能修補；能力長期變化。',
  },
];

// Mentor方案不能只靠同一句話是否剛好命中多組關鍵字。每一個主章都有
// 預先校準的章際路徑，讓Mentor能從「當下穩定 → 根系辨識 → 現實落地」
// 進行整合，同時維持最多三章的Token預算。
const MENTOR_RELATED_CHAPTERS = {
  C01: ['C03', 'C04'],
  C02: ['C06', 'C08'],
  C03: ['C06', 'C07'],
  C04: ['C07', 'C08'],
  C05: ['C07', 'C08'],
  C06: ['C02', 'C07'],
  C07: ['C08', 'C09'],
  C08: ['C07', 'C10'],
  C09: ['C07', 'C10'],
  C10: ['C08', 'C09'],
};

const SAFETY_TERMS = ['自殺', '不想活', '傷害自己', '傷害別人', '家暴', '暴力', '胸痛', '呼吸困難', '昏倒', '大量出血'];
const CATEGORY_TERMS = {
  health: ['健康', '身體', '疼痛', '失眠', '生病', '醫療'],
  relationship: ['感情', '婚姻', '伴侶', '父母', '小孩', '家人', '朋友', '人緣'],
  wealth: ['財富', '金錢', '收入', '負債', '投資', '財務'],
  peace: ['事業', '工作', '學業', '平安', '壓力', '職場'],
};

function countMatches(text, terms) {
  return terms.reduce((score, term) => score + (text.includes(term) ? Math.max(2, term.length) : 0), 0);
}

function buildClarificationQuestion(category) {
  if (category === 'relationship') return '這件關係中，你最想先釐清的是當下反應、反覆根系，還是界線與下一步行動？';
  if (category === 'health') return '這次最需要先處理的是身體承載、內在方向，還是能持續完成的生活行動？';
  if (category === 'wealth' || category === 'peace') return '這件事目前最卡的是角色與責任、流程與交付，還是能力與資源不足？';
  return '這件事此刻最需要先處理的是停下舊反應、看懂反覆模式，還是完成一個現實行動？';
}

function buildClarificationOptions(category) {
  if (category === 'relationship') return [
    { label: '先安住自己的反應', routeHint: '我想先停下觸發與自動反應' },
    { label: '看懂關係反覆根系', routeHint: '我想辨識關係中的反覆模式、界線與集體慣性' },
    { label: '找到界線與下一步', routeHint: '我想守住界線、找出主軸並完成下一步' },
  ];
  if (category === 'health') return [
    { label: '先照顧身體承載', routeHint: '我想先辨識身體訊號與生命力缺口' },
    { label: '分辨本心與勉強', routeHint: '我想分辨本心、身體與使命逼迫' },
    { label: '建立可持續行動', routeHint: '我想盤點能力並做七天微型實驗' },
  ];
  if (category === 'wealth' || category === 'peace') return [
    { label: '釐清角色與責任', routeHint: '我想釐清角色位置、責任與界線' },
    { label: '補流程與交付缺口', routeHint: '我想主動補洞、改善流程並形成交付' },
    { label: '盤點能力與資源', routeHint: '我想盤點生命力、生產力、承擔力、執行力與創新力' },
  ];
  return [
    { label: '先安住自己的反應', routeHint: '我想先停下觸發與自動反應', mentorPath: ['C01', 'C03', 'C04'] },
    { label: '看懂反覆模式', routeHint: '我想辨識反覆模式、潛意識與集體慣性', mentorPath: ['C03', 'C06', 'C07'] },
    { label: '找主軸與下一步', routeHint: '我想重看全局、找出主軸並完成下一步', mentorPath: ['C04', 'C07', 'C08'] },
  ];
}

export function routeRgQuestion(question, plan = 'chapter', mentorPath = null) {
  const normalized = String(question || '').trim();
  const ranked = RG_CHAPTERS.map((chapter, index) => ({
    chapter,
    index,
    score: countMatches(normalized, chapter.routeWhen),
  })).sort((a, b) => b.score - a.score || a.index - b.index);

  const hasMatch = ranked[0].score > 0;
  const primary = hasMatch ? ranked[0].chapter : null;
  const isMentor = plan === 'mentor';
  const matched = ranked
    .filter(({ chapter, score }) => score > 0 && chapter.id !== primary.id)
    .map(({ chapter }) => chapter);
  const calibratedRelated = (primary ? MENTOR_RELATED_CHAPTERS[primary.id] : [])
    .map((id) => RG_CHAPTERS.find((chapter) => chapter.id === id))
    .filter(Boolean);
  const explicitMentorPath = isMentor && Array.isArray(mentorPath)
    ? mentorPath.map((id) => RG_CHAPTERS.find((chapter) => chapter.id === id)).filter(Boolean).slice(0, 3)
    : null;
  const selected = explicitMentorPath?.length
    ? explicitMentorPath
    : isMentor
    ? [primary, ...calibratedRelated, ...matched].filter(Boolean)
      .filter((chapter, index, chapters) => chapters.findIndex(({ id }) => id === chapter.id) === index)
      .slice(0, 3)
    : primary ? [primary] : [];
  const category = Object.entries(CATEGORY_TERMS)
    .map(([name, terms]) => ({ name, score: countMatches(normalized, terms) }))
    .sort((a, b) => b.score - a.score)[0];

  const primaryCategory = category?.score > 0 ? category.name : 'general';
  return {
    plan: isMentor ? 'mentor' : 'chapter',
    chapters: selected,
    primaryCategory,
    needsClarification: !hasMatch,
    clarificationQuestion: hasMatch ? null : buildClarificationQuestion(primaryCategory),
    clarificationOptions: hasMatch ? [] : buildClarificationOptions(primaryCategory),
    requiresSafetyReferral: SAFETY_TERMS.some((term) => normalized.includes(term)),
  };
}

export function buildRgContext(question, plan = 'chapter', options = {}) {
  const routing = routeRgQuestion(question, plan, options.mentorPath);
  const activeChapter = options.activeChapterId
    ? routing.chapters.find(({ id }) => id === options.activeChapterId)
    : null;
  const loadedChapters = activeChapter ? [activeChapter] : routing.chapters;
  const chapterContext = loadedChapters.map((chapter) => [
    `${chapter.id}｜${chapter.title}`,
    `必要背景：${chapter.summary}`,
    `五秒歸零：${chapter.prompt}`,
    `今日行動：${chapter.action}`,
    `Evidence：${chapter.evidence}`,
  ].join('\n')).join('\n\n');
  const mentorIntegration = routing.plan === 'mentor' && routing.chapters.length === 3
    ? {
        theme: `從${routing.chapters[0].id}穩住當下，經${routing.chapters[1].id}辨識深層模式，再以${routing.chapters[2].id}完成現實落地。`,
        steps: routing.chapters.map((chapter, index) => `${index + 1}. ${chapter.id}：${chapter.action}`),
        evidence: routing.chapters.map((chapter) => `${chapter.id}：${chapter.evidence}`),
      }
    : null;
  const mentorContext = mentorIntegration
    ? activeChapter
      ? `\n\nMentor旅程：${routing.chapters.map(({ id, title }) => `${id} ${title}`).join(' → ')}\n目前只載入：${activeChapter.id}`
      : `\n\nMentor跨章整合：${mentorIntegration.theme}\n分階段行動：\n${mentorIntegration.steps.join('\n')}\n跨章Evidence：\n${mentorIntegration.evidence.join('\n')}`
    : '';
  const context = `${RG_KERNEL}\n\n${chapterContext}${mentorContext}\n\n回答格式：${RG_RESPONSE_FRAME.join('／')}`;
  return {
    ...routing,
    userEcho: String(question || '').trim(),
    mentorIntegration,
    activeChapter,
    context,
    loadedChars: context.length,
    savedPercent: Math.max(0, Math.round((1 - context.length / RG_FULL_REFERENCE_CHARS) * 1000) / 10),
    knowledgeVersion: RG_KNOWLEDGE_VERSION,
  };
}

export function buildRgGuidance(question, plan = 'chapter') {
  const result = buildRgContext(question, plan);
  const primary = result.chapters[0];
  if (result.needsClarification || !primary) {
    return {
      ...result,
      reply: `我聽見你在說：「${result.userEcho}」\n\n我還不想替你猜成C01。先確認一點：${result.clarificationQuestion}\n\n你可以選：${result.clarificationOptions.map(({ label }) => label).join('／')}`,
    };
  }
  const related = result.chapters.slice(1).map(({ id, title }) => `${id}「${title}」`).join('、');
  const mentorPath = result.mentorIntegration
    ? result.chapters.map(({ id, title }) => `${id}「${title}」`).join(' → ')
    : '';
  return {
    ...result,
    reply: [
      `我聽見你在說：「${result.userEcho}」`,
      mentorPath
        ? `AI Angel辨識到的三章路徑是：${mentorPath}。我們不一次把三章都丟給你；先只走最相關的第1站。`
        : `我先把這次事件連到 ${primary.id}「${primary.title}」。`,
      `第1站｜${primary.id}「${primary.title}」\n可能的生命主題：${primary.summary}`,
      `五秒歸零：${primary.prompt}`,
      `今天先做：${primary.action}`,
      `留下Evidence：${primary.evidence}`,
      mentorPath ? `完成並回看這一步後，再依實際 Evidence 決定是否走向 ${related}；不是現在同時處理三章。` : '',
      !result.mentorIntegration && related ? `Mentor跨章時可再連結：${related}。` : '',
      result.requiresSafetyReferral ? '這段文字含有立即安全風險訊號，請先聯絡當地緊急服務、可信任的人或合格醫療／心理專業。' : '',
    ].filter(Boolean).join('\n\n'),
  };
}
